import React from "react";
import PropTypes from "prop-types";
// import classNames from "classnames";
import { version } from "../../config";
import { Typography } from "@material-ui/core";
import logo from "../../assets/images/logo.png";
import classNames from "classnames";

const Title = ({ classes }) => (
	<>
		{version.office ? (
			<img src={logo} alt="logo" className={classNames(classes.logo)} />
		) : (
			<Typography
				className={classes.title}
				noWrap
				variant="h2"
				style={{
					color: "#000000"
				}}
			>
				{"JE RECHERCHE:"}
			</Typography>
		)}
	</>
);

Title.propTypes = {
	classes: PropTypes.object.isRequired
};

export default Title;
